import * as Yup from 'yup';
import { emailSchema } from './fieldSchemas';

export const ForgotPasswordSchema = Yup.object().shape({
  email: emailSchema({
    required: true,
    requiredMessage: 'E-posta adresi zorunlu',
  }),
});
